/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DocumentUploadPreviewTranslations } from './DocumentUploadPreviewTranslations';
import type { DocumentUploadVerificationTranslations } from './DocumentUploadVerificationTranslations';
import type { DocumentUploadStatusLabels } from './DocumentUploadStatusLabels';

export interface DocumentUploadTranslations {
    upload_button_label: string;
    upload_document_button_label: string;
    upload_failed_try_again: string;
    required_label: string;
    expire_label: string;
    check_upload_modal: string;
    back_button_label: string;
    next_button_label: string;
    preview: DocumentUploadPreviewTranslations;
    verification: DocumentUploadVerificationTranslations;
    document_upload_example: string;
    your_document: string;
    document_upload_uploaded_label: string;
    document_upload_requirements: string;
    use_camera_button: string;
    select_file_button: string;
    unknown_error: string;
    status_label: DocumentUploadStatusLabels;
}
